import { render, staticRenderFns } from "./bongoFaq.vue?vue&type=template&id=25c85904&scoped=true&"
import script from "./bongoFaq.vue?vue&type=script&lang=js&"
export * from "./bongoFaq.vue?vue&type=script&lang=js&"
import style0 from "./bongoFaq.vue?vue&type=style&index=0&id=25c85904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c85904",
  null
  
)

export default component.exports